module.exports = __webpack_public_path__ + "img/house64_ua.6e629d83.webp";